"use strict";

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _gatsbyBrowser = require("./gatsby-browser");

exports.wrapRootElement = _gatsbyBrowser.wrapRootElement;